import { c as _c } from "react/compiler-runtime";
import { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import GroupCreateConfigHeader from "../GroupCreateConfigHeader";
import GroupCreateCIC from "./GroupCreateCIC";
import GroupCreateLevel from "./GroupCreateLevel";
import GroupCreateRep from "./GroupCreateRep";
import GroupCreateTDH from "./GroupCreateTDH";
import GroupCreateCollections from "./nfts/GroupCreateCollections";
import GroupCreateNfts from "./nfts/GroupCreateNfts";
import GroupCreateWallets, { GroupCreateWalletsType } from "./wallets/GroupCreateWallets";
export default function GroupCreateConfig(t0) {
  const $ = _c(36);
  const {
    level,
    tdh,
    cic,
    rep,
    wallets,
    excludeWallets,
    nfts,
    iAmIncluded,
    setLevel,
    setTDH,
    setCIC,
    setRep,
    setWallets,
    setExcludeWallets,
    setNfts
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GroupCreateConfigHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== level || $[2] !== setLevel) {
    t2 = <GroupCreateLevel level={level} setLevel={setLevel} />;
    $[1] = level;
    $[2] = setLevel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== setTDH || $[5] !== tdh) {
    t3 = <GroupCreateTDH tdh={tdh} setTDH={setTDH} />;
    $[4] = setTDH;
    $[5] = tdh;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cic || $[8] !== setCIC) {
    t4 = <GroupCreateCIC cic={cic} setCIC={setCIC} />;
    $[7] = cic;
    $[8] = setCIC;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== rep || $[11] !== setRep) {
    t5 = <GroupCreateRep rep={rep} setRep={setRep} />;
    $[10] = rep;
    $[11] = setRep;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  let t7;
  if ($[13] !== nfts || $[14] !== setNfts) {
    t6 = <GroupCreateNfts nfts={nfts} setNfts={setNfts} />;
    t7 = <GroupCreateCollections nfts={nfts} setNfts={setNfts} />;
    $[13] = nfts;
    $[14] = setNfts;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="tw-space-y-4 sm:tw-space-y-5 tw-col-span-full">{t1}<div className="tw-gap-x-6 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-y-4 sm:tw-gap-y-6">{t2}{t3}{t4}{t5}{t6}{t7}</div></div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== iAmIncluded || $[25] !== setWallets || $[26] !== wallets) {
    t9 = <GroupCreateWallets type={GroupCreateWalletsType.INCLUDE} iAmIncluded={iAmIncluded} wallets={wallets} setWallets={setWallets} walletsLimit={10000} />;
    $[24] = iAmIncluded;
    $[25] = setWallets;
    $[26] = wallets;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== excludeWallets || $[29] !== iAmIncluded || $[30] !== setExcludeWallets) {
    t10 = <GroupCreateWallets type={GroupCreateWalletsType.EXCLUDE} wallets={excludeWallets} iAmIncluded={iAmIncluded} setWallets={setExcludeWallets} walletsLimit={1000} />;
    $[28] = excludeWallets;
    $[29] = iAmIncluded;
    $[30] = setExcludeWallets;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t8 || $[34] !== t9) {
    t11 = <div className="tw-grid tw-grid-cols-2 tw-gap-x-6 tw-gap-y-6 sm:tw-gap-y-8">{t8}{t9}{t10}</div>;
    $[32] = t10;
    $[33] = t8;
    $[34] = t9;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
}